import React from "react";

export const IconImg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
            fill="currentColor"
            d="M16 4C6.118 4 4 6.118 4 16q0 .691.014 1.333c-.014.667.428.922 1.32.164 1.884-1.604 4.16-2.83 6.666-2.83 1.582 0 3.049.55 4.334 1.318 1.33.794 1.438.682 2.352 0a6.64 6.64 0 0 1 3.98-1.318 6.63 6.63 0 0 1 3.575 1.038c1.759 1.12 1.756 1.202 1.756-.372C27.899 6.023 25.656 4 16 4m4 7.333a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        />
        <path
            fill="currentColor"
            d="M12 17.333c1.054 0 2.125.41 3.157 1.058.843.53 1.008.946.876 2.276q-.033.328-.033.666a6.65 6.65 0 0 0 2.166 4.918C20 27.931 20 27.873 18.38 27.95q-1.106.051-2.38.05c-6.692 0-9.823-.971-11.148-4.667-.365-1.018-.211-1.293.481-2.107 1.7-1.998 4.049-3.893 6.667-3.893"
        />
        <path
            fill="currentColor"
            d="M22.667 16a5.333 5.333 0 1 0 2.709 9.928l1.681 1.681a1.333 1.333 0 1 0 1.886-1.885l-1.681-1.681A5.333 5.333 0 0 0 22.667 16M20 21.333a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.333 0"
        />
    </svg>
);

export const IconVideo = () => (
    <div className="video-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="play-icon">
            <path fill="currentColor"
                  stroke="black" /* Цвет контура */
                  strokeWidth="0.8" /* Толщина контура */
                  d="M4.699 1.334c-.866 0-.866 3.333-.866 6.666s0 6.667.866 6.667c1.218 0 10.801-5 10.801-6.667S5.917 1.334 4.7 1.334"/>
        </svg>
    </div>
)

export const YandexDzen = () => (
    <svg width="200" height="169" viewBox="0 0 575 169" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_45_468)">
            <path d="M490.5 128.04H510.49V91.52H554.24V128.04H574.23V40H554.24V74.86H510.49V40H490.5V128.04Z"
                  fill="#545459"/>
            <path
                d="M480.78 88.0501C480.78 56.1101 464.12 36.3901 437.87 36.3901C411.62 36.3901 391.9 58.3301 391.9 83.7401C391.9 110.4 410.65 131.23 440.09 131.23C453.56 131.23 466.06 126.79 476.47 117.9L467.72 104.99C460.22 110.41 450.92 114.57 440.78 114.57C425.78 114.57 415.09 105.96 412.03 91.9301H480.77V88.0401L480.78 88.0501ZM411.9 76.2401C414.54 62.4901 425.09 53.1901 437.87 53.1901C450.65 53.1901 458.98 61.9401 461.2 76.2401H411.9Z"
                fill="#545459"/>
            <path
                d="M345.93 131.24C370.51 131.24 385.79 119.58 385.79 104.02C385.79 94.4399 380.37 86.1099 367.04 83.4699L366.21 83.3299V82.4999L367.04 82.3599C379.68 79.8599 384.95 72.0799 384.95 62.9199C384.95 48.7599 371.76 36.6699 348.84 36.6699C333.29 36.6699 318.15 42.4999 305.65 51.8099L313.57 65.4199C322.32 59.3099 334.68 53.3399 347.45 53.3399C359.11 53.3399 365.5 58.3399 365.5 64.9999C365.5 71.1099 359.81 75.6899 347.59 76.1099L326.48 77.0799V90.4099L347.59 91.3799C360.5 92.0699 365.5 96.6599 365.5 102.35C365.5 109.02 358.56 114.85 344.53 114.85C330.5 114.85 318.98 109.16 309.12 102.35V120.96C315.09 124.43 328.14 131.24 345.92 131.24H345.93Z"
                fill="#545459"/>
            <path
                d="M291.64 108.18V40H221.79L216.65 85.41C214.43 104.02 208.87 108.18 198.87 108.18H198.04V148.04H218.04V128.04H283.31V148.04H303.31V108.18H291.65H291.64ZM271.78 111.38H223.04V110.55C229.01 108.33 234.15 104.58 235.68 90L239.15 56.53H271.78V111.38Z"
                fill="#545459"/>
            <path
                d="M83.68 168.04H84.35C117.72 168.04 137.09 164.68 150.81 151.36C164.8 137.23 168.03 117.73 168.03 84.49V83.55C168.03 50.32 164.8 30.95 150.81 16.68C137.1 3.36 117.59 0 84.36 0H83.69C50.32 0 30.94 3.36 17.22 16.68C3.23 30.81 0 50.32 0 83.55V84.49C0 117.72 3.23 137.09 17.22 151.36C30.81 164.68 50.32 168.04 83.68 168.04Z"
                fill="#545459"/>
            <path
                d="M148.04 82.75C148.04 82.11 147.52 81.58 146.88 81.55C123.91 80.68 109.93 77.75 100.15 67.97C90.35 58.17 87.43 44.18 86.56 21.16C86.54 20.52 86.01 20 85.36 20H82.68C82.04 20 81.51 20.52 81.48 21.16C80.61 44.17 77.69 58.17 67.89 67.97C58.1 77.76 44.13 80.68 21.16 81.55C20.52 81.57 20 82.1 20 82.75V85.43C20 86.07 20.52 86.6 21.16 86.63C44.13 87.5 58.11 90.43 67.89 100.21C77.67 109.99 80.59 123.94 81.47 146.87C81.49 147.51 82.02 148.03 82.67 148.03H85.36C86 148.03 86.53 147.51 86.56 146.87C87.44 123.94 90.36 109.99 100.14 100.21C109.93 90.42 123.9 87.5 146.87 86.63C147.51 86.61 148.03 86.08 148.03 85.43V82.75H148.04Z"
                fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_45_468">
                <rect width="574.23" height="168.04" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)

export const YandexIcon = () => (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.04 12c0-5.523 4.476-10 10-10 5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.524 0-10-4.477-10-10z"
              fill="#FC3F1D"/>
        <path
            d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.487H7.49l2.695-4.014c-1.55-1.111-2.42-2.19-2.42-4.015 0-2.288 1.595-3.85 4.62-3.85h3.003v11.868H13.32V7.666z"
            fill="#fff"/>
    </svg>
)
export const GoogleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            fill="#4285F4"/>
        <path
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            fill="#34A853"/>
        <path
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            fill="#FBBC05"/>
        <path
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            fill="#EA4335"/>
        <path d="M1 1h22v22H1z" fill="none"/>
    </svg>
)

export const Youtube = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="150" height="150">
        <path fill="#FF3D00"
              d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"/>
        <path fill="#FFF" d="M20 31L20 17 32 24z"/>
    </svg>
)
